import * as tslib_1 from "tslib";
import { serialize, Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
const ɵ0 = () => UserNameDisplayResultDto, ɵ1 = () => Date;
export class SharedWorkspaceResultDto {
    toConfigString() {
        return serialize(this.toJson());
    }
    toJson() {
        return {
            id: this.id,
            key: this.key,
            name: this.name,
            categoryCode: this.categoryCode,
            createdBy: this.createdBy,
            createdDate: this.createdDate,
            isSystemType: this.isSystemType,
            allowEdit: this.allowEdit,
            allowDelete: this.allowDelete,
            allowExternalUsers: this.allowExternalUsers
        };
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], SharedWorkspaceResultDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], SharedWorkspaceResultDto.prototype, "createdDate", void 0);
export { ɵ0, ɵ1 };
